import { useCallback } from 'react';

import { CastType } from '../../types';
import { useConditionState } from './useConditionState';

export const useCastTypeState = () => {
  const { condition, setCondition } = useConditionState();
  const castType = 'castType' in condition ? condition.castType : undefined;
  const setCastType = useCallback(
    (newCastType?: CastType) =>
      setCondition((curentCondition) => ({ ...curentCondition, castType: newCastType })),
    [setCondition],
  );
  return { castType, setCastType };
};
